/**
 * CMS-agnostic types. No Sitecore, no Sanity: just shapes.
 *
 * The primitives exported here are written by hand, such as the `Link` and
 * `Image` the adapters produce. `generated/` holds the content type of every
 * CMS component, generated from the CMS team's component map by
 * `npm run import:cms-schema`: import one by its path
 * (`@eneco/cms-types/generated/LegislationStep`), and never edit it.
 */

export type { Image } from './image';
export type { Link } from './link';
export { linkWithUrl } from './link';
export { readField } from './read-field';
export { selectOptions } from './select-options';
export { asRichText } from './rich-text';
export type { RichText } from './rich-text';
export type { Locale } from './locale';
export { asPlaceholderName } from './placeholder-name';
export type { PlaceholderName } from './placeholder-name';
export type { Placeholders } from './placeholders';
export type { Rendering } from './rendering';
